import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CustomerOfferConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getCustomerOfferStateEndpoint(): string {
		// todo: OBGB-11551 rename customer-offer to customerOffer
		return this.service.get(
			(x) => x.common.campaign["customer-offer"]!.endpoints!.offerState,
			"v1/campaigncustomeroffersstate/:customerOfferFilter"
		);
	}

	getCampaignOfferStateEndpoint(): string {
		// todo: OBGB-11551 rename customer-offer to customerOffer
		return this.service.get(
			(x) => x.common.campaign["customer-offer"]!.endpoints!.campaignOfferState,
			"v1/campaignofferstate?offertype=:offerType"
		);
	}

	getOfferStateEnabled(): boolean {
		// todo: OBGB-11551 rename customer-offer to customerOffer
		return this.service.get((x) => x.common.campaign["customer-offer"]!.offerStateEnabled, false);
	}
}
